import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    const key = document.querySelector('meta[name="stripe-public-key"]')?.getAttribute('content') || '';
    stripePromise = loadStripe(key);
  }

  return stripePromise;
}
